// import axios from "axios";

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//     "X-WhatsApp-Token": process.env.REACT_APP_API_TOKEN
//   }
// });

// export const getDepartments = async () => {
//   try {
//     const response = await api.get("/departments");
//     if (response.status === 200) {
//       return response;
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     throw error;
//   }
// };

// export const getDoctors = async (deptId) => {
//   try {
//     console.log(deptId)
//     const response = await api.get(`/doctors?dept_id=${deptId}`);
//     if (response.status === 200) {
//       return response;
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     throw error;
//   }
// };

// export const sendOtp = async (phone) => {
//   try {
//     const response = await api.post("/send_otp", { phone });
//     if (response.status === 200) {
//       console.log(response)
//       return response; 
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     throw error;
//   }
// };

// export const verifyOtp = async (phone, otp) => {
//   try {
//     const response = await api.post("/verify_otp", { phone, otp });
//     if (response.status === 200) {
//       return response;
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     throw error;
//   }
// };

// export const fetchPatientByPhone = async (rawPhone) => {
//   const phone = String(rawPhone || "").replace(/\D/g, "").slice(-10);
//   const res = await api.get("/patient", { params: { phone } });
//   if (res.status !== 200) {
//     throw new Error(`Unexpected response status: ${res.status}`);
//   }
//   return res.data?.success ? res.data.data : null;
// };


// export const getDepartmentAvailableSlots = async (doctorId, date) => {
//   try {
//     const response = await api.post("/doctor-available-slots", {
//       doctorId, 
//       date,
//     });

//     if (response.status === 200) {
//       const resData = response.data.data;

//       if (
//         resData?.slots &&
//         Array.isArray(resData.slots) &&
//         resData.slots[0]?.doctors &&
//         Array.isArray(resData.slots[0].doctors)
//       ) {
//         return resData.slots[0].doctors.map((doc) => {
//           const normalizedId = String(doc.doctorId).replace(/^DOC/, "");
//           return {
//             doctorId: normalizedId,
//             doctorName: doc.doctorName,
//             availableSlots: doc.availableSlots || [],
//           };
//         });
//       }

//       return [];
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     throw error;
//   }
// };

// export const registerPatient = async (payload) => {
//   try {
//     const response = await api.post("/register_patient", payload);
//     if (response.status === 200) {
//       return response.data; 
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     console.error("Error registering patient:", error);
//     throw error;
//   }
// };

// export const bookSlot = async (payload) => {
//   try {
//     const response = await api.post("/book_slot", payload);
//     if (response.status === 200) {
//       return response.data; 
//     } else {
//       throw new Error(`Unexpected response status: ${response.status}`);
//     }
//   } catch (error) {
//     console.error("Error booking slot:", error);
//     throw error;
//   }
// };

// export const getPatientBookings = async (patientId) => {
//   const result = {
//     upcoming: [],
//     past: []
//   };

//   try {
//     // status = 1 → upcoming
//     const resUpcoming = await api.get("/bookings", {
//       params: { patient_id: patientId, status: 1 }
//     });
//     if (resUpcoming.data?.success) {
//       result.upcoming = resUpcoming.data.data;
//     }

//     // status = 2 → past
//     const resPast = await api.get("/bookings", {
//       params: { patient_id: patientId, status: 2 }
//     });
//     if (resPast.data?.success) {
//       result.past = resPast.data.data;
//     }
//   } catch (err) {
//     console.error("Error fetching bookings:", err);
//   }

//   return result;
// };




import axios from "axios";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-WhatsApp-Token": process.env.REACT_APP_API_TOKEN,
  },
});

const handleError = (error, context = "API Error") => {
  console.error(`${context}:`, error?.response || error?.message || error);
  const msg =
    error?.response?.data?.message ||
    error?.response?.data?.detail ||
    error?.message ||
    "Something went wrong";
  toast.error(msg);
  throw new Error(msg);
};

// ------------------- Departments -------------------
export const getDepartments = async () => {
  try {
    const { data } = await api.get("/departments");
    return data;
  } catch (error) {
    handleError(error, "Fetching departments");
  }
};

export const getDoctors = async (visitType,deptId,visitDate) => {
  try {
    const { data } = await api.get(`/doctors`, { params: { dept_id: deptId,visit_type: visitType,visit_date: visitDate  } });
    return data;
  } catch (error) {
    handleError(error, "Fetching doctors");
  }
};

// ------------------- OTP -------------------
export const sendOtp = async (phone) => {
  try {
    const { data } = await api.post("/send_otp", { phone });
    return data;
  } catch (error) {
    handleError(error, "Sending OTP");
  }
};

export const verifyOtp = async (phone, otp) => {
  try {
    const { data } = await api.post("/verify_otp", { phone, otp });
    return data;
  } catch (error) {
    handleError(error, "Verifying OTP");
  }
};

// ------------------- Patient -------------------
export const fetchPatientByPhone = async (rawPhone) => {
  try {
    const phone = String(rawPhone || "").replace(/\D/g, "").slice(-10);
    const { data } = await api.get("/patient", { params: { phone } });
    return data?.success ? data.data : null;
  } catch (error) {
    handleError(error, "Fetching patient");
  }
};

// ------------------- Slots -------------------
export const getDepartmentAvailableSlots = async (doctorId, date, fee_type) => {
  try {
    const { data } = await api.post("/doctor-available-slots", {
      doctorId,
      date,
      fee_type,
    });

    if (
      data?.data?.slots &&
      Array.isArray(data.data.slots) &&
      data.data.slots[0]?.doctors
    ) {
      return data.data.slots[0].doctors.map((doc) => ({
        doctorId: String(doc.doctorId).replace(/^DOC/, ""),
        doctorName: doc.doctorName,
        availableSlots: doc.availableSlots || [],
        consultationFee: doc.consultationFee,
      }));
    }
    return [];
  } catch (error) {
    handleError(error, "Fetching available slots");
  }
};

// ------------------- Doctor Fees -------------------
export const getDoctorFees = async (doctorId, fee_type, patient_id) => {
  try {
    const { data } = await api.post("/doctor-fees", {
      doctorId,
      fee_type, patient_id
    });

    if (data?.data?.fees) {
      const fees = data.data.fees;

      return {
        doctorId: String(fees.doctorId).replace(/^DOC/, ""),
        consultationFee: fees.consultationFee,
        telemedicineEnabled: fees.telemedicineEnabled,
      };
    }

    return null;
  } catch (error) {
    handleError(error, "Fetching doctor fee");
    return null;
  }
};

// ------------------- Doctor Fees -------------------
export const checkDoctorWalkins = async (doctorId, date) => {
  try {
    const { data } = await api.post("/check-doctor-walkins", {
      doctorId,
      date,
    });

    if (data?.data) {
      const walkins = data.data;

      return {
        doctorId: walkins.doctorId,
        selectedDate: walkins.selectedDate,
        bookedWalkins: walkins.bookedWalkins,
        allowedWalkins: walkins.allowedWalkins,
        availableWalkins: walkins.availableWalkins,
      };
    }

    return null;
  } catch (error) {
    handleError(error, "Checking doctor walk-ins");
    return null;
  }
};



// ------------------- Register & Booking -------------------
export const registerPatient = async (payload) => {
  try {
    const { data } = await api.post("/register_patient", payload);
    return data;
  } catch (error) {
    handleError(error, "Registering patient");
  }
};

export const bookSlot = async (payload) => {
  try {
    const { data } = await api.post("/book_slot", payload);
    return data;
  } catch (error) {
    handleError(error, "Booking slot");
  }
};

// ------------------- Bookings -------------------
export const getPatientBookings = async (patientId) => {
  const result = { upcoming: [], past: [] };
  try {
    const [resUpcoming, resPast] = await Promise.all([
      api.get("/bookings", { params: { patient_id: patientId, status: 1 } }),
      api.get("/bookings", { params: { patient_id: patientId, status: 2 } }),
    ]);
    if (resUpcoming.data?.success) result.upcoming = resUpcoming.data.data;
    if (resPast.data?.success) result.past = resPast.data.data;
  } catch (error) {
    handleError(error, "Fetching bookings");
  }
  return result;
};

// ------------------- Master-list -------------------
export const fetchMasterLists = async () => {
  try {
    const { data } = await api.get("/master-lists");
    return data;
  } catch (error) {
    handleError(error, "Fetching Data");
  }
};

// ------------------- Payment  -------------------
export const updatePaymentStatus = async (paymentData) => {
  try {
    const { data } = await api.put(`/payment`, paymentData);
    return data;
  } catch (error) {
    handleError(error, "Updating payment status");
  }
};

// ------------------- Personnal Details  -------------------
export const updatePatientDetails = async (payload) => {
  try {
    const { data } = await api.put("/update_patient", payload);
    return data;
  } catch (error) {
    handleError(error, "Registering patient");
  }
};

export const createRazorPayOrder = async (payload) => {
  try {
    const { data } = await api.post("/razorpay/payments/create_order", payload);
    return data;
  } catch (error) {
    handleError(error, "Creating RazorPay Order");
  }
};

// ------------------- Slots WebSocket -------------------

export const createSlotsWebSocket = (onMessage) => {
  const baseHttpUrl = process.env.REACT_APP_API_BASE_URL || "";
  const wsUrl = baseHttpUrl
    .replace(/^http/, "ws")
    .replace(/\/$/, "") + "/ws/slots";

  const ws = new WebSocket(wsUrl);

  ws.onopen = () => console.log("✅ WS connected");
  ws.onclose = (e) => console.log("❌ WS closed", e.code, e.reason);
  ws.onerror = (e) => console.error("🔥 WS error", e);
  ws.onmessage = (event) => {
    console.log("📩 RECEIVED RAW:", event.data);
    try {
      const data = JSON.parse(event.data);
      onMessage(data);
    } catch {
      console.warn("Non JSON message:", event.data);
    }
  };


  return ws;
}